module.exports = {
  BLOCK: {
    TITLE: 'title',
    TEXT: 'text'
  }
}
